export default "__VITE_ASSET__29d7f039__"